import { useDroppable } from '@dnd-kit/core'
import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

export function GroupDropTarget({ groupId, children, className }: { groupId: string; children: ReactNode; className?: string }) {
  const { setNodeRef, isOver } = useDroppable({ id: `group:${groupId}` })
  return (
    <div
      ref={setNodeRef}
      className={cn(className, isOver && 'ring-2 ring-inset ring-primary/40 bg-primary/5 rounded-full')}
    >
      {children}
    </div>
  )
}
